import INTERNAL_REQUEST_EVENTS from '../events/internalRequest.events';
import InternalRequestNotificationsEventCatcher from '../eventCatchers/internalRequest/InternalRequestNotificationsEventCatcher';

const processInternalRequestEvents = ({ event, data, dispatch }) => {
  switch (event) {
    case INTERNAL_REQUEST_EVENTS.NOTIFICATION: {
      InternalRequestNotificationsEventCatcher.process(data, dispatch);
      break;
    }

    default: {
      // eslint-disable-next-line no-console
      console.warn('There are no cases for this event', { event, data });
    }
  }
};

export default processInternalRequestEvents;
